import {
  createContext,
  type CSSProperties,
  type RefObject,
  useContext,
} from 'react';

export type MenuContext = {
  darkMode: boolean;
  hasBorder: boolean;
  isOpen: boolean;
  popperAttributes: { [key: string]: undefined | { [key: string]: string } };
  popperElement: RefObject<HTMLDivElement>;
  popperStyles: { [key: string]: CSSProperties };
  referenceElement: RefObject<HTMLDivElement>;
  toggleMenu: () => void;
};

export const MenuContext = createContext<MenuContext>({
  darkMode: false,
  hasBorder: false,
  isOpen: false,
  popperAttributes: {},
  popperElement: { current: null },
  popperStyles: {},
  referenceElement: { current: null },
  toggleMenu: () => {},
});

export const useMenuContext = () => useContext(MenuContext);
